module.exports = __webpack_public_path__ + "static/media/bronzeStar.809fe195.svg";